<button type="button" class="btn btn-primary"
        (onShown)="onShown()" (onHidden)="onHidden()"
        popover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">
  Live demo
</button>
<br>
<br>
<pre class="card card-block card-header mb-3">Event: {{message}}</pre>
